import { render, staticRenderFns } from "./OfferstartingBusiness.vue?vue&type=template&id=5f638c7c&scoped=true"
import script from "./OfferstartingBusiness.vue?vue&type=script&lang=js"
export * from "./OfferstartingBusiness.vue?vue&type=script&lang=js"
import style0 from "./OfferstartingBusiness.vue?vue&type=style&index=0&id=5f638c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f638c7c",
  null
  
)

export default component.exports